// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"f7e286a2","567":"6ea697f2","634":"f7e286a2","707":"e3e6586e","745":"e8b255e6"}[chunkId] + ".chunk.js";
};